import styled from "styled-components";

export const RenderTransition = styled.div`
    animation: fadein .5s;
    @keyframes fadein {
    from { opacity: 0}
    to   { opacity: 1}
    }
`